<template>
    <div class="fixed z-50 bottom-[60px] lg:bottom-[82px] right-[8px] lg:right-[20px] w-[54px] lg:w-[64px] py-[12px] lg:py-[24px] text-center text-[#666] bg-white rounded-[12px]"
        style="box-shadow:0px 0px 12px 0px rgba(0,0,0,0.05)">
        <div class="hover:text-[#3e90ff] relative cursor-pointer">
            <a-popover placement="left">
                <template slot="content">
                    <div class="lg:block p-[4px] rounded-[8px] bg-white">
                        <p class="mt-[5px] mb-[3px] text-center text-[16px] text-[#666] leading-[26px]">
                            <span>白工：</span>
                            <span class="text-[#3e90ff] tracking-wide text-[18px]">{{ phone }}</span>
                        </p>
                    </div>
                </template>
                <div>
                    <span class="text-[22px]"><a-icon type="phone" /></span>
                    <p class="pt-[6px] pb-[20px] lg:pt-[8px] lg:pb-[22px] text-[10px] lg:text-[12px] leading-[14px]">
                        电话咨询
                    </p>
                </div>
            </a-popover>
        </div>
        <div class="hover:text-[#3e90ff] relative cursor-pointer">
            <a-popover placement="left">
                <template slot="content">
                    <div class="lg:block p-[4px] rounded-[8px] bg-white">
                        <div id="wl-qrcode-contact-nav" style="display:flex;justify-content:center;width:100%">
                            <img src="@/assets/imgs/wechat.jpg"
                                style="width: 160px; height: 160px; border: 1px solid rgb(238, 238, 238); border-radius: 10px;">
                        </div>
                        <p class="mt-[5px] mb-[3px] text-center text-[14px] text-[#666] leading-[26px]">微信扫一扫添加官方微信
                        </p>
                    </div>
                </template>
                <div>
                    <span class="text-[22px]">
                        <a-icon type="wechat" />
                    </span>
                    <p class="pt-[6px] pb-[20px] lg:pt-[8px] lg:pb-[22px] text-[10px] lg:text-[12px] leading-[14px]">
                        微信咨询
                    </p>
                </div>
            </a-popover>
        </div>
        <div class="hover:text-[#3e90ff] relative cursor-pointer" @click="openPage">
            <span class="text-[22px]">
                <a-icon type="solution" />
            </span>
            <p class="pt-[6px] pb-[20px] lg:pt-[8px] lg:pb-[22px] text-[10px] lg:text-[12px] leading-[14px]">
                申请演示
            </p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'homePageContact',
    data() {
        return {
            phone: '13364061501'
        }
    },
    methods: {
        openPage() {
            window.open('/apply')
        }
    }
}
</script>
